import { render } from "./LimitedPromotionDays.vue?vue&type=template&id=28317406&scoped=true"
import script from "./LimitedPromotionDays.vue?vue&type=script&lang=js"
export * from "./LimitedPromotionDays.vue?vue&type=script&lang=js"

import "./LimitedPromotionDays.vue?vue&type=style&index=0&id=28317406&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28317406"]])

export default __exports__